import { render, staticRenderFns } from "./NewTuberCulinSkin.vue?vue&type=template&id=26a4efb6&scoped=true"
import script from "./NewTuberCulinSkin.vue?vue&type=script&lang=js"
export * from "./NewTuberCulinSkin.vue?vue&type=script&lang=js"
import style0 from "./NewTuberCulinSkin.vue?vue&type=style&index=0&id=26a4efb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4efb6",
  null
  
)

export default component.exports